// import { StateService, api}         from '@/services';
// import axios                from 'axios';
// import CustomStore          from 'devextreme/data/custom_store';
// import store from '../store/index.js';

const uuid = () => {
    let crypto = window.crypto || window.msCrypto;
    return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
}

const getKeyByValue = (object, value) => {
    return Object.keys(object).find(key => object[key] === value);
};

const userRoleEnum = {
    // 'Unknown'             : 0,
    'SmartSales Admin'    : 1,
    'Sales Administrator' : 2,
    'Sales Manager'       : 3,
    'Sales Rep'           : 4,
};

const orderStatusEnum = {
    // 'Unknown'             : 0,
    'Uncommitted'            : 1,
    'Committed'              : 2,
    'Submitted'              : 3,
};

const dealerStatusEnum = {
    'Unregistered' : 1,
    'Registered'   : 2,
    'Discontinued' : 3,
};


const phoneNumTypeEnum = {
    'Work'      : 1,
    'Home'      : 2,
    'Mobile'    : 3,
    'Fax'       : 4,
    'Billing'   : 5,
    'Shipping'  : 6,
    'Contact'   : 7,
    'Other'     : 8,
};

const validatorMsgMapBase = {
    'required'           : 'Required',
    'email'              : 'Must be a valid Email',
    'hasUppercase'       : 'Must have an uppercase letter',
    'hasDigit'           : 'Must have a digit',
    'hasNonAlphanumeric' : 'Must have non-alphanumeric character',
};

const defaultProduct = () => {
    return {
        MfgId: null,
        MfgCode: "",
        PartNumber: "",
        ReferenceCode: "",
        StockCode: "",
        Summary: "",
        Description: "",
        Retail: null,
        DealerCost: 0,
        CustomerCost: null,
        MinimumPrice: 0,
        MaximumPrice: null,
        Discount1: 0,
        Discount2: 0,
        ThumbnailURL: '',
    };
};

const extractProdData = (href) => {
    // console.log('attempting to extract product data from href: ', href);
    let arr = href.split('?')[1].split('|');
    let prodData = defaultProduct();
    prodData.MfgCode     = arr[0];
    prodData.PartNumber  = arr[1].trim();
    prodData.Retail      = arr[2];
    prodData.Description = handleDecodeDesc(arr[3]);
    // console.log('productData', prodData);
    return prodData;
};

function handleDecodeDesc(str) {
    let decodedDesc;
    try {
        decodedDesc      = decodeURIComponent(str);
    } catch(e) {
        decodedDesc      = 'Error Decoding Description';
    }
    return decodedDesc.replace(/;/g,', ');
}


const deepCopyObject = (obj) => {
    return JSON.parse(JSON.stringify(obj))
}

export {
    uuid,
    getKeyByValue,
    userRoleEnum,
    dealerStatusEnum,
    validatorMsgMapBase,
    phoneNumTypeEnum,
    defaultProduct,
    extractProdData,
    orderStatusEnum,
    deepCopyObject,
};
